import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import useConfiguration from '../../../../utils/useConfiguration';
import { useIntegrationContext } from '../../IntegrationProvider';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Metadata from '@afosto/app-components-react/Metadata';
import isDefined from '@afosto/utils/isDefined';
import { getUISchema } from '../../../../components/IntegrationForm/getUISchema';
import translations from './translations';

const IntegrationConfiguration = () => {
  const intl = useIntl();
  const { app, integration } = useIntegrationContext();

  const configurationSchema = isDefined(app?.config_schema)
    ? JSON.parse(atob(app.config_schema))
    : null;
  const configuration = useConfiguration({ app, integration });
  const uiSchemas = getUISchema(intl, app?.code, {});

  return (
    <Card>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <Box px={2} pb={2}>
        <Metadata
          metadata={configuration}
          schema={configurationSchema}
          uiSchema={uiSchemas?.configuration ?? {}}
        />
      </Box>
    </Card>
  );
};

export default IntegrationConfiguration;
